module.exports = __webpack_public_path__ + "static/GT-Haptik-Medium-Rotalic-01f432a326dfd67d3906b1eeab2e90a3.woff2";